import styled from "styled-components";
export const GreyText = styled.span`
  color: #a8a8a8;
  font-size: 20px;
  margin-bottom: 10px;
`;
